var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var m2 = _vm.topBarHeight()
  var m3 = !(m2 == 0) ? _vm.topBarHeight() : null
  var m4 = !(m2 == 0) ? _vm.topBarTop() : null
  var l0 =
    _vm.show_type == 10
      ? _vm.__map(_vm.listData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m5 = _vm.hasImages(item)
          return {
            $orig: $orig,
            m5: m5,
          }
        })
      : null
  var l1 =
    _vm.show_type == 20
      ? _vm.__map(_vm.listData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m6 = _vm.hasImages(item)
          return {
            $orig: $orig,
            m6: m6,
          }
        })
      : null
  var l2 =
    _vm.show_type == 40
      ? _vm.__map(_vm.productData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m7 =
            _vm.index_open_city == 0 ||
            (_vm.index_open_city == 1 &&
              _vm.isInArray2(_vm.city_supplier_ids, item.shop_supplier_id))
          var g0 = m7 ? _vm.productData.length : null
          return {
            $orig: $orig,
            m7: m7,
            g0: g0,
          }
        })
      : null
  var g1 =
    _vm.show_type == 40 ? _vm.productData.length == 0 && !_vm.isloadding : null
  var l3 =
    _vm.show_type == 30
      ? _vm.__map(_vm.childlist, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m8 = _vm.hasImages(item)
          return {
            $orig: $orig,
            m8: m8,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        l0: l0,
        l1: l1,
        l2: l2,
        g1: g1,
        l3: l3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }